'use strict';

module.exports = (outer, inner) => ({ outer, inner });